module.exports = __webpack_public_path__ + "static/img/ill4.cfc0da1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/envi/ill4.png
// module id = xrq2
// module chunks = 1